import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
} from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { Creditor } from '../../../../../../../_base-shared/models/Entity/Creditor';
import { CreditorService } from '../../../creditor/creditor.service';
import { ReportService } from '../../report.service';
import { CaseCreditorStatus } from '../../../../../../../_base-shared/models/Status/CaseCreditorStatus';
import { CaseCreditorStatusService } from '../../../status/case-creditor/status-list/case-creditor-status.service';

@Component({
  standalone: false,
  selector:    'app-automated-creditor-report',
  templateUrl: './automated-creditor-report.component.html',
  styles:      []
})
export class AutomatedCreditorReportComponent implements OnInit {
  public form: UntypedFormGroup;
  public isLoading                                       = 0;
  public creditors: Array<Creditor>                      = [];
  public caseCreditorStatuses: Array<CaseCreditorStatus> = [];

  constructor(
    private toast: ToastrService,
    private reportService: ReportService,
    private fb: UntypedFormBuilder,
    public dialogRef: MatDialogRef<AutomatedCreditorReportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private creditorService: CreditorService,
    private caseCreditorStatusService: CaseCreditorStatusService,
  ) {
  }

  ngOnInit(): void {
    this.buildForm();
    this.fetchCreditors();
    this.fetchCaseCreditorStatuses();
  }

  buildForm(): void {
    this.form = this.fb.group({
      case_creditor_status_id: [null, Validators.required],
      creditor_id:             [null, Validators.required],
    });
  }

  sendReportData(): void {
    if ( ! this.form.valid) {
      return;
    }

    this.isLoading++;
    this.reportService.generateAutomatedCreditorReport(this.form.value).pipe(finalize(() => this.isLoading--))
      .subscribe(res => {
          this.dialogRef.close(true);
          this.toast.success(res.message);

        },
        err => console.error(err),
      );
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  private fetchCreditors(): void {
    this.isLoading++;
    this.creditorService.index({select_all: 1, active: 1})
      .pipe(finalize(() => this.isLoading--))
      .subscribe(res => {
          this.creditors = res.data;
        },
        err => console.error(err)
      );
  }

  private fetchCaseCreditorStatuses(): void {
    this.isLoading++;
    const data = {
      'append[]': ['name'],
      select_all: 1,
    };
    this.caseCreditorStatusService.index(data).pipe(finalize(() => this.isLoading--))
      .subscribe(res => {
        this.caseCreditorStatuses = res.data;
      });
  }
}
